module.exports = __webpack_public_path__ + "static/media/logo-hensel-ps.302310dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo-hensel-ps.png
// module id = 1454
// module chunks = 0